import { useState } from "react";
import { Box, Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import SearchBar from "../../components/SearchBar";
import { useNavigate } from "react-router-dom";
import { Dispatch, SetStateAction } from "react";

const SubadminListTopbar = ({
  searchTerm,
  setSearchTerm,
  setDebounceSearchTerm,
}: {
  searchTerm: string;
  setSearchTerm: Dispatch<SetStateAction<string>>;
  setDebounceSearchTerm: Dispatch<SetStateAction<string>>;
}) => {
  const navigate = useNavigate();

  return (
    <>
      <div className="table_header">
        <div className="left_s">
          <Box className="search_box">
            <SearchBar
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              setDebouncedSearchTerm={setDebounceSearchTerm}
              placeholder="Search..."
            />
          </Box>
        </div>
        <div className="right_s">
          <Button
            className="btn btn_primary"
            onClick={() => navigate("/manage-subadmin/roles")}
          >
            Roles
          </Button>
          <Button
            className="btn btn_primary"
            onClick={() => navigate("/manage-subadmin/add")}
          >
            <AddIcon /> Add Sub-Admin
          </Button>
        </div>
      </div>
    </>
  );
};

export default SubadminListTopbar;
